
import Tratamentos from "../components/Tratamentos";
import Servicos from "../components/Servicos";
import HeaderGeral from "../components/HeaderGeral";
import Footer from "../components/Footer";
import HeaderHome from "../components/HeaderHome";
    function TratamentosPage() {
    return (
        <div className={"overflow-y-hidden"}>
            <HeaderHome></HeaderHome>
            <Tratamentos></Tratamentos>
            <Footer></Footer>
        </div>




    )
}

export default TratamentosPage;
